var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16826_24688)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "#ABADAD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.00016,
    cy: 5.33268,
    r: 2.16667,
    fill: "#7C7D7D",
    stroke: "#7C7D7D"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_16826_24688",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 13.1435C2 11.0396 3.70558 9.33398 5.80952 9.33398H10.1905C12.2944 9.33398 14 11.0396 14 13.1435C14 13.2487 13.9147 13.334 13.8095 13.334H2.19048C2.08528 13.334 2 13.2487 2 13.1435Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2 13.1435C2 11.0396 3.70558 9.33398 5.80952 9.33398H10.1905C12.2944 9.33398 14 11.0396 14 13.1435C14 13.2487 13.9147 13.334 13.8095 13.334H2.19048C2.08528 13.334 2 13.2487 2 13.1435Z",
    fill: "#7C7D7D",
    stroke: "#7C7D7D",
    strokeWidth: 2,
    mask: "url(#path-3-inside-1_16826_24688)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-2_16826_24688",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 13,
    width: 12,
    height: 3,
    rx: 0.666667
  })), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 13,
    width: 12,
    height: 3,
    rx: 0.666667,
    fill: "#7C7D7D",
    stroke: "#7C7D7D",
    strokeWidth: 2,
    mask: "url(#path-4-inside-2_16826_24688)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16826_24688"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.f2b9243804646ec09f74113409f4106a.svg";
export { ForwardRef as ReactComponent };